import {getAuth} from "shj-utils";

const config =  () => {
  const config = {
    cacheDisabled: false,
    cacheType: "REMOTE",
    searchFormConfig: {
      labelCol: {
        xs: {span: 6},
        sm: {span: 6},
        xl: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 20},
        xl: {span: 20},
      },
    },
    columns: [
      {
        title: '线索ID',
        dataIndex: 'id',
        width: 190,
        fixed: 'left',
        render: 'clueIdRender',
      },
      {
        title: '客户姓名',
        dataIndex: 'name',
        width: 200,
        render: 'nameRender'
      },
      {
        title: '客户电话',
        dataIndex: 'phone',
        width: 200,
        render: 'checkPhone',
        minWidth: 200,
      },
      {
        title: '拨打状态',
        dataIndex: 'totalCount',
        width: 180,
        render: 'callStatusRender',
      },
      {
        title: '房屋属性',
        dataIndex: 'houseNatureName',
        width: 120,
        hidden: true,
      },
      {
        title: '楼盘名称',
        dataIndex: 'buildingName',
        width: 150,
        ellipsis: true,
      },
      {
        title: '军种',
        dataIndex: 'channelTypeName',
        width: 100,
        hidden: true,
      },
      {
        title: '客户来源',
        dataIndex: 'channelName',
        width: 260,
        ellipsis: true,
      },
      {
        title: '公司',
        dataIndex: 'orgName',
        width: 180,
      },
      {
        title: '云客服',
        dataIndex: 'seat',
        width: 150,
      },
      {
        title: '营销部',
        dataIndex: 'salesDept',
        width: 150,
        ellipsis: true,
        hidden: true,
      },
      {
        title: '营销员',
        dataIndex: 'sales',
        width: 100,
      },
      {
        title: '到店次数',
        dataIndex: 'arriveCount',
        width: 100,
      },
      {
        title: '首访时间',
        dataIndex: 'firstDate',
        itemType: 'dateTime',
        width: 180,
      },
      {
        title: '最后跟进时间',
        dataIndex: 'lastFollowTime',
        itemType: 'dateTime',
        width: 180,
      },
      {
        title: '创建时间',
        dataIndex: 'createdTime',
        itemType: 'dateTime',
        width: 180,
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render: 'stateRender',
      },
      {
        title: '建筑面积',
        dataIndex: 'constructArea',
        width: 120,
        hidden: true,
      },
      {
        title: '套内面积',
        dataIndex: 'innerArea',
        width: 120,
        hidden: true,
      },
      {
        title: '优化师',
        dataIndex: 'advertName',
        width: 100,
        hidden: true,
      },
      {
        title: '线索账号',
        dataIndex: 'accountId',
        width: 150,
        hidden: true,
      },
      {
        title: '广告计划',
        dataIndex: 'plan',
        width: 150,
        hidden: true,
      },
      {
        title: '最后跟进内容',
        dataIndex: 'lastFollowContent',
        width: 180,
        ellipsis: true,
        hidden: true,
      },
      {
        title: '无效中',
        dataIndex: 'invalidFlag',
        width: 120,
        render: (v) => v ? '是' : '否',
        hidden: true,
      },
      {
        title: '备注',
        dataIndex: 'remark',
        width: 180,
        ellipsis: true,
        hidden: true,
      },
      {
        title: '操作',
        dataIndex: '#',
        width: 245,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    search: [
      {
        name: 'nameLike',
        label: '客户姓名',
      },
      {
        name: 'phone',
        label: '客户电话',
        itemType: 'number',
        span: 120,
      },
      {
        name: 'id',
        label: '线索ID',
        formItemProps: {
          getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
        },
      },
      {
        name: 'trackPlanId',
        label: '商机ID',
        formItemProps: {
          getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
        },
      },
      {
        name: 'orderCode',
        label: '订单号',
      },
      {
        name: 'bizType',
        label: '需求标签',
        itemType: 'select',
        key: 'key',
        labelKey: 'description',
        data: 'typeListArr',
      },
      {
        name: 'orgId',
        label: '公司',
        itemType: 'select',
        key: 'id',
        labelKey: 'name',
        data: 'companyList',
        events: ['onChange:onCompanyChange'],
      },
      {
        name: 'deptId',
        label: '营销部',
        span: 120,
        itemType: 'tree',
        key: 'id',
        labelKey: 'label',
        data: 'saleDept',
        showSearch: true,
        notFoundContent: '请选择公司或无匹配数据',
        events: ['onChange:onMarketerDepChange'],
      },
      {
        name: 'ucenterUserId',
        label: '营销员',
        span: 120,
        itemType: 'select',
        key: 'ucenterUserId',
        labelKey: 'userName',
        data: 'salesman',
        notFoundContent: '请选择公司或无匹配数据',
      },
      {
        name: 'designerOrgId',
        label: '设计部',
        span: 120,
        itemType: 'tree',
        key: 'id',
        labelKey: 'label',
        data: 'designDept',
        showSearch: true,
        notFoundContent: '请选择公司或无匹配数据',
        events: ['onChange:onDesignDeptChange'],
      },
      {
        name: 'designerId',
        label: '设计师',
        span: 120,
        itemType: 'select',
        key: 'ucenterUserId',
        labelKey: 'userName',
        data: 'designer',
        notFoundContent: '请选择公司或无匹配数据',
      },
      {
        name: 'callUserId',
        label: '云客服',
        itemType: 'select',
        key: 'ucenterUserId',
        labelKey: 'userName',
        data: 'seat',
        span: 120,
      },
      {
        name: 'advertUserId',
        itemType: 'select',
        key: 'ucenterUserId',
        labelKey: 'userName',
        data: 'anchor',
        label: '优化师',
      },
      {
        name: 'statusList',
        label: '线索状态',
        itemType: 'select',
        mode: 'multiple',
        key: 'key',
        labelKey: 'description',
        data: 'clueStatusEnum',
      },
      {
        name: 'trackPlanStatusList',
        label: '商机状态',
        itemType: 'select',
        mode: 'multiple',
        data: 'bizStatus',
        key: 'value',
        labelKey: 'label',
      },
      {
        name: 'orderStatusList',
        label: '订单状态',
        itemType: 'select',
        mode: 'multiple',
        key: 'key',
        labelKey: 'description',
        data: 'orderStateEnum',
      },
      {
        name: 'dealStatusList',
        label: '成交状态',
        itemType: 'select',
        mode: 'multiple',
        key: 'key',
        labelKey: 'description',
        data: 'dealStatusEnum',
      },
      {
        name: 'houseNatureCode',
        label: '房屋属性',
        span: 120,
        itemType: 'select',
        key: 'key',
        labelKey: 'description',
        data: 'houseNatureEnums',
      },
      {
        name: 'buildingId',
        label: '楼盘',
        span: 120,
        itemType: 'select',
        key: 'id',
        labelKey: 'name',
        data: 'buildingId',
        notFoundContent: '请选择公司或无匹配数据',
      },
      {
        name: 'channelIds',
        label: '客户来源',
        span: 160,
        itemType: 'custom',
        render: 'treeSelect',
        colSpan: 2,
        wrapForm: true,
      },
      {
        name: 'channelBrandId',
        label: '品牌',
        span: 120,
        itemType: 'select',
        key: 'id',
        labelKey: 'brandName',
        data: 'channelBrand',
      },
      // {
      //   name: 'plan',
      //   label: '最小建筑面积',
      // },
      // {
      //   name: 'plan',
      //   label: '最大建筑面积',
      // },
      // {
      //   name: 'plan',
      //   label: '最后跟进',
      //   labelProps: { width : 65 },
      // },
      {
        label: '派单类型',
        name: 'dispatchType',
        itemType: 'select',
        key: 'key',
        labelKey: 'description',
        data: 'dispatchTypeEnum',
      },
      {
        label: '军种',
        name: 'channelTypeId',
        itemType: 'select',
        data: 'channelType',
        labelKey: 'typeName',
        key: 'id',
      },
      {
        label: '已加企微',
        name: 'addQvFlag',
        itemType: 'select',
        data: 'stateList',
        key: 'value',
      },
      {
        label: '签单意向',
        name: 'signIntentionCode',
        itemType: 'select',
        data: 'signBillIntentEnum',
        labelKey: 'description',
        key: 'key',
      },
      {
        label: '广告计划',
        name: 'plan',
      },
      {
        label: '飞鱼线索',
        name: 'feiyuFlag',
        itemType: 'select',
        data: 'stateList',
        key: 'value',
      },
      {
        label: '飞鱼拨号状态',
        name: 'feiyuDial',
        itemType: 'select',
        data: [{label: '未拨通', value: false}, {label: '已拨通', value: true}],
        key: 'value',
      },
      {
        label: '飞鱼拨号次数',
        name: 'feiyuFollowTimes',
        itemType: 'number',
        precision: 0,
        min: 0,
      },
      {
        label: '是否内容留资',
        name: 'contentShareFlag',
        itemType: 'select',
        data: 'stateList',
        key: 'value',
      },
      {
        label: '最小建筑面积',
        name: 'constructAreaMin',
        itemType: 'number'
      },
      {
        label: '最大建筑面积',
        name: 'constructAreaMax',
        itemType: 'number'
      },
      {
        label: '最小套内面积',
        name: 'innerAreaMin',
        itemType: 'number'
      },
      {
        label: '最大套内面积',
        name: 'innerAreaMax',
        itemType: 'number'
      },
      {
        name: 'firstDate',
        label: '首访日期',
        placeholder: ['首访日期起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'lastFollowTime',
        label: '最后跟进时间',
        placeholder: ['最后跟进时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'createdTime',
        label: '创建时间',
        placeholder: ['创建时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'signUpTime',
        label: '报名时间',
        placeholder: ['报名时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'dispatchTime',
        label: '派单时间',
        placeholder: ['派单时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'validityTime',
        label: '认定有效时间',
        placeholder: ['认定有效时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'appointmentTime',
        label: '预约到店时间',
        placeholder: ['预约到店时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'signTime',
        label: '签单时间',
        placeholder: ['签单时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'startWorkTime',
        label: '在建时间',
        placeholder: ['在建时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
      {
        name: 'completedTime',
        label: '完工时间',
        placeholder: ['完工时间起', '止'],
        span: 140,
        itemType: 'autoDate',
        showTime: 'true',
      },
    ],
    footer: [
      {
        label: '导出',
        render: 'exportRender',
      },
      {
        // 查重
        label: '线索查重',
        type: 'primary',
        auth: 'salesWorkBenchSeatSearchClueRepeat',
        events: ['onClick:onSearchRepeat'],
      },
    ],
    batchActions: [
      {
        label: '批量改派设计师',
        type: 'primary',
        auth: 'salesWorkBenchBatchReassignmentDesign',
        events: ['onClick:onBatchChangeDesign'],
      },
      {
        label: '批量改派营销员',
        type: 'primary',
        auth: 'salesWorkBenchBatchReassignmentSale',
        events: ['onClick:onBatchChange'],
      },
      {
        label: '批量改派云客服',
        type: 'primary',
        auth: 'salesWorkBenchBatchReassignmentSeat',
        events: ['onClick:onBatchChangeSeat'],
      },
    ],
  }
  const addObjs = {
    salesWorkBenchClueAddBySeat: {
      label: '新增',
      type: 'primary',
      auth: 'salesWorkBenchClueAddBySeat',
      events: ['onClick:onSeatAdd'],
    },
    salesWorkBenchClueAdd: {
      label: '新增',
      type: 'primary',
      auth: 'salesWorkBenchClueAdd',
      events: ['onClick:onAddNormal'],
    },
    salesWorkBenchClueAddByChannel: {
      label: '新增',
      type: 'primary',
      auth: 'salesWorkBenchClueAddByChannel',
      events: ['onClick:onChannelAdd'],
    }
  }
  const auth = getAuth();
  const addAuthCount = ['salesWorkBenchClueAdd', 'salesWorkBenchClueAddBySeat', 'salesWorkBenchClueAddByChannel'].filter(val => auth[val]).length;

  // console.log(addAuthCount)
  if(addAuthCount === 1 ) {
    const currentKey = ['salesWorkBenchClueAdd', 'salesWorkBenchClueAddBySeat', 'salesWorkBenchClueAddByChannel'].find(key => auth[key])
    config.footer.push(addObjs[currentKey])
  } else if (addAuthCount > 1){
    config.footer.push({
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    })
  }
  return config
}

export default config

